/**
 * return `true` when `value` is an `Object`
 *
 * return `false` when `value` is a primitive data type, a function, or a class
 */
// isObject :: a -> Boolean
function isObject(value: unknown): value is object {
  return typeof value === 'object' && value !== null;
}

export default isObject;
